
import React from "react";
import profileImg from "../assets/sibilleFrengerProfile.jpg";

function UeberMich() {
  return (
    <main className="section section--page about">
      <div className="container about__inner">
        <div className="about__text">
          <h1 className="page-title">Über mich</h1>
          <p>
            Mein Name ist Sibille Frenger und ich wohne mit meiner großen Familie im schönen Kölner Norden.
          </p>
          <p>
            Seit über 30 Jahren arbeite ich als ausgebildete Floristin in der Blumenbranche, seit 2007 mobil in der von mir gegründeten Blumen-Werkstatt.
          </p>
          <p>
            Für mich sind Blumen ein Lebensgefühl, welches Frohsinn, Leichtigkeit, Geborgenheit und Schönheit ausdrückt.
            Mit sehr viel Begeisterung und Leidenschaft kombiniere ich Blumen in Form und Farben zu wunderschönen Arrangements.
          </p>
          <p>
            Mir ist es wichtig, dass meine Arbeiten Menschen inspirieren und bei ihrem Anblick glücklich machen. Egal zu welchem Anlass, ob Taufe, Hochzeit, Kommunion oder auch in traurigen Stunden.
          </p>
          <p>
            Dadurch, dass ich ausschließlich mobil arbeite und somit keine festen Geschäftszeiten habe, bin ich zeitlich sehr flexibel.
            Gerne führe ich mit Ihnen ein unverbindliches Beratungsgespräch, um Ihr Fest zu einem unvergesslichen Erlebnis zu gestalten.
          </p>
          <p>
            Herzlichst,<br/>
            Ihre Sibille Frenger
          </p>
        </div>
        <div className="about__image">
          <img src={profileImg} alt="Sibille Frenger" />
        </div>
      </div>
    </main>
  );
}

export default UeberMich;
